import {
  IFormDocument,
  ISelect,
} from 'app/services/api5-service/api.interface';

import { DocHelper } from 'utils/dochelper';

import { TypedControlBase } from '../typed-controls';

export interface SelectControlWithValue extends TypedControlBase {
  readonly control: ISelect;
  readonly type: 'select';
  value: string[] | string;
}

/**
 * Map control metadata to typed object with value from doc state
 *
 * @param control - control metadata
 * @param doc - doc
 */
export function getTypeControlForSelect(
  control: ISelect,
  doc: IFormDocument,
): SelectControlWithValue {
  return {
    // @HACK BE send value for mixed select because... some reason, don't know why. This is wrong, there must be no value at all.
    // Mixed fields are empty and should display placeholder or something like this. So pretend, that this value is empty for ispui-select placeholder
    value: control.$mixed ? '' : DocHelper.getSelectValue(control.$name, doc),
    control,
    type: 'select',
  } as SelectControlWithValue;
}
